<template>
  <div class="recommendlist">
    <Scroller
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      :no-data-text-data.sync="noDataText"
      @on-infinite="onInfinite"
      @on-refresh="onRefresh"
      class="my_scroller"
      ref="my_scroller"
    >
      <product-list
        :productlist="list"
        :markPointData="{ scenepoint: 'SEARCHSUGGEST' }"
      ></product-list>
    </Scroller>
  </div>
</template>

<script>
import productList from '../common/productList'
import Scroller from '../common/Scroller'

export default {
  name: 'recommendList',
  components: {
    productList,
    Scroller
  },
  data: function () {
    return {
      searchValue: '',
      list: [],
      nowPage: 0,
      refresh: false,
      loading: false,
      finished: false,
      noDataText: '—— 客官，木有啦~ ——'
    }
  },
  mounted: function () {
    if (this.$route.query.searchval) {
      this.searchValue = decodeURIComponent(this.$route.query.searchval)
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!sessionStorage.askPositon || from.path == '/') {
      // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next((vm) => {
        vm.nowPage = 0
      })
    } else {
      next((vm) => {
        if (vm.$route.query.searchval) {
          vm.searchValue = decodeURIComponent(vm.$route.query.searchval)
        }
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  watch: {
    searchValue(n) {
      this.nowPage = 0
      this.onInfinite()
    }
  },
  methods: {
    getData: function () {
      var that = this
      var url =
        this.$ajax.getRecommendItemList_URL +
        '?pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize +
        '&keyword=' +
        this.searchValue
      that.$customRequestAjax(url).then(function (res) {
        if (res.data.code == 200) {
          if (that.nowPage === 1) {
            that.list = res.data.recommenditemlist
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.recommenditemlist)
          }
          that.loading = false
          if (res.data.recommenditemlist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      this.getData()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getData()
    }
  }
}
</script>

<style scoped lang="scss">
.recommendlist {
  background: #fff;
  padding: 0 0.12rem;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/recommendList.vue